import axios from "axios";
import {baseUrlApiOtodis, xApiKeyOtodis} from "../../config/api/apiConfig";

class FulfillmentService {
    private axios = axios.create({
        baseURL: baseUrlApiOtodis,
    });
    private axiosFile = axios.create({
        baseURL: baseUrlApiOtodis,
        responseType: 'blob'
    });

    public setToken(token: string) {
        this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    }

    public async getConfigFulfillment(params?: any) {
        const queries = {}
        try {
            return await this.axios.get<any>('/config/fulfillment/amarta', {
                headers: {
                    "X-Api-Key": xApiKeyOtodis,
                },
                params: {
                    ...queries,
                }
            });
        } catch (e: any) {
            throw new Error(e.response.data.message);
        }
    }

    public async closingFulfillment(inputData?: any) {
        try {
            return await this.axios.post<any>('/closing-fulfillment',
                inputData,{
                    headers: {
                        "Content-Type": "application/json",
                        "X-Api-Key": xApiKeyOtodis
                    }
                });
        } catch (e: any) {
            throw new Error(e.response.data.error.message);
        }
    }

    public async updateJsonStockOtodis(inputData?: any) {
        try {
            return await this.axios.post<any>('/update-otodis-json-stock',
                inputData,{
                    headers: {
                        "Content-Type": "application/json",
                        "X-Api-Key": xApiKeyOtodis
                    }
                });
        } catch (e: any) {
            throw new Error(e.response.data.error.message);
        }
    }
}

export const fulfillmentService = new FulfillmentService();
